// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24.37 19L8.11 28.46A11 11 0 0119 19h5.37zM8 7.48L24.37 17H19c-4.63 0-8.7 2.43-11 6.07V7.48zM6 4v28l24-14L6 4z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>";
// Exports
module.exports = code;